<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="卡号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getListHandler" placeholder="虚拟号/ICCID/接入号"
                    clearable></el-input>
            </el-form-item>
            <el-form-item label="订单号：">
                <el-input v-model.trim="searchForm.orderNo" @keyup.enter.native="getListHandler" placeholder="订单号"
                    clearable></el-input>
            </el-form-item>

            <el-form-item label="代理商选择：">
                <el-select v-model="searchForm.agentId" filterable>
                    <el-option v-for="item in agentListOption" :value="item.id" :key="item.id" clearable
                        :label="item.name"></el-option>
                </el-select>
            </el-form-item>


            <el-form-item label="验证：">
                <el-input v-model="searchForm.checkoutPass" @keyup.enter.native="getListHandler" placeholder=""
                    clearable></el-input>
            </el-form-item>


            <!-- <el-form-item label="丢单时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item> -->
            <el-form-item class="btnArea">
                <el-button type="primary" plain icon="el-icon-search" @click="getListHandler($event)">查 询</el-button>
                <!-- <el-button type="primary" plain @click="exportOrderInfoHandle()">导 出 数 据</el-button> -->
            </el-form-item>



        </el-form>
        <p style="color:red;text-align:center;" v-if="remarkMap&&remarkMap.countNum">
            交易总数：{{ remarkMap.countNum }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 交易金额：{{ remarkMap.commission }}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </p>


        <el-table :data="tbpg.tableData" border fit highlight-current-row style="width: 100%;"
            :header-cell-style="{ background: '#f5f5f5' }" :default-sort="{ prop: 'createTime', order: 'descending' }">
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column label="ICCID" width="160" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="order_no" label="订单号" align="center"></el-table-column>
            <el-table-column prop="id" label="代理订单号" align="center"></el-table-column>
            <el-table-column prop="commission" label="丢单金额/元" align="center"></el-table-column>
            <el-table-column prop="package_name" label="套餐名称" align="center"></el-table-column>
            <el-table-column prop="price" label="购买金额/元" align="center"></el-table-column>
            <el-table-column prop="agent_name" label="代理名称" align="center"></el-table-column>
            <el-table-column prop="stateName" label="退回状态" align="center"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="160" align="center"></el-table-column>
            <el-table-column label="操作" align="center" width="80">
                <template slot-scope="scope">
                    <el-button @click="backPrice(scope.row.id)" type="text" style="color: red;"
                        size="small">退回佣金</el-button>
                </template>
            </el-table-column>

        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize" background
            layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
        </el-pagination>





    </div>
</template>
<script>
import common from '@/utils/common.js';
export default {
    data() {
        return {
            remarkMap: {},
            agentListOption: [],
            editRules: {
                name: { required: true, message: '请输入轮训名称', trigger: 'blur' },
                type: { required: true, message: '请输入轮询类型', trigger: 'blur' },
                supplierCodes: { required: true, message: '请输入轮询通道', trigger: 'blur' }
            },
            confirmExportDialogVisible: false,
            searchForm: {
                checkoutPass: '',
                iccid: '',
                agentId: '',
                agentName: '',
                orderNo: ''

            },
            branchSupplierOption: [],//运营商字典
            editVisibale: false,
            editForm: {
                id: "",
                sleepTime: "",
                name: "",
                remark: "",
                type: "",
                threadSize: "",
                state: "0",
                supplierCodes: [],
                supplierNames: "",
            },

            branchSupplierOption: [],
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            //批量操作
            dialogVisible: false,
            limitForm: {
                supplierCode: null,
                limitSpeed: null,
            },
            statusGroup: [],
            limitFormRules: {
                limitSpeed: [
                    { required: true, message: '请选择状态', trigger: 'change' }
                ]
            },
            //批量操作  end

            //单卡限速操作
            singleLimitDialog: false,
            singleLimitForm: {
                iccid: null,
                limitSpeed: null,
            },
            singleLimitFormRules: {
                iccid: [
                    { required: true, message: '请输入iccid', trigger: 'blur' }
                ],
                limitSpeed: [
                    { required: true, message: '请选择状态', trigger: 'change' }
                ]
            }
        }
    },
    methods: {
        backPrice(id) {
            this.$confirm('确定要退回佣金吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                common.sysRequest('agent/agent/loss/list/back', { id: id }, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('退回成功');
                        this.getListHandler();
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            }).catch(() => {

            });
        },
        exportOrderInfoHandle() {
            common.deleteSpaceKey(this.searchForm);

            this.$confirm('确定导出吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                common.sysRequest('export/lossOrder', this.searchForm, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
            }).catch(() => {

            });
        },




        goToDetailPage(row) {
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        getListHandler($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            common.sysRequest('agent/agent/loss/list/info', data, 'post').then(res => {
                this.remarkMap = res.data.data.remarkMap;
                common.listCallback(this, res, 'tbpg');
            })
        },

        handleSizeChange(val) {
            this.tbpg.pageSize = val;
            this.getListHandler();
        },
        handleCurrentChange(val) {
            this.tbpg.currentPage = val;
            this.getListHandler();
        },


        handleChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }

        },
        sureRechargeHandler() {
            if (this.$refs.uploadFile.uploadFiles.length == 0) {
                this.$message.error('请选择文件');
                return;
            }
            this.$refs.limitForm.validate(valid => {
                if (valid) {
                    this.$refs.uploadFile.submit();
                    this.rechargeVisible = false;
                }
            });
        },

        handleSuccess(res) {
            if (res.code == 200) {
                this.getListHandler();
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
            this.cancel();
            this.$refs.uploadFile.clearFiles();
        },



        formatLimitSpeed(code) {

            let v = this.statusGroup.filter(function (item) {
                if (code == item.code) {
                    return item;
                }
            });
            return v[0] && v[0].description ? v[0].description : "";
        },


        singleLimitSpeed() {
            let data = new FormData();
            Object.keys(this.singleLimitForm).forEach((key) => {
                data.append(key, this.singleLimitForm[key]);
            });

            this.$refs.limitForm.validate(valid => {
                if (valid) {
                    common.sysRequest("sim/price/limit/speed", data, 'post').then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(res.data.message);
                            this.getListHandler();
                            this.cancelsSngleLimit();
                        } else {
                            this.$message.error(res.data.message)
                        }
                    }).catch(err => console.error(err));
                }
            });

        },

        cancelsSngleLimit() {
            this.singleLimitForm.limitSpeed = null;
            this.singleLimitForm.iccid = null;
            this.singleLimitDialog = false;
        },
    },

    computed: {

    },

    created() {
        common.getAgentListOptionCom1(this, 'agentListOption');
        this.getListHandler();

        common.getBranchSupplierOptionCom(this, 'branchSupplierOption');

        //获取状态值
        common.sysRequest('pkg/all/pkgType', {}, 'get').then(res => {
            if (res.data.code == 200) {
                this.branchSupplierOption = res.data.data;
            }
        })
    },
}
</script>
<style lang="less" scoped></style>

